import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompetenciesService } from '../competencies.service';
import { OthersService } from '../others/othersDataService';
import { TrainingsWidgetModel } from 'src/app/Models/OthersWidgetModel';
import { CMFService } from 'src/app/services/CMFDashboard/CMFService';

@Component({
  selector: 'app-trainings',
  templateUrl: './trainings.component.html',
  styleUrls: ['./trainings.component.css']
})
export class TrainingsComponent implements OnInit, OnChanges {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: CompetenciesService,
    private othersService: OthersService,
    private cmfService:CMFService
  ) { }

  @Input() CMFDashBoardData: TrainingData;
  trainingcount: trainingtype;
  trainingdata:TrainingData;

  competencyId: number;
  subCompetencyId: number;
  competencyname: string;
  subCompetencyName: string;

  ngOnInit() {
    this.service.profileStatus$.subscribe(x => {
      this.competencyId = x;
      if (this.competencyId == null) {
        this.competencyId = Number(sessionStorage.getItem("compId"))

      }
      this.service.competencyName$.subscribe(x => {
        this.competencyname = x
        if (this.competencyname == null || this.competencyname == "") {
          this.competencyname = sessionStorage.getItem("compTitle")
        }
      })

    });

    this.othersService.id$.subscribe(id => {
      this.subCompetencyId = id;
      if (this.subCompetencyId == null || this.subCompetencyId == 0) {
        this.subCompetencyId = Number(sessionStorage.getItem("SubcompId"))
      }
    });

    this.othersService.name$.subscribe(name => {
      this.subCompetencyName = name;
      if (this.subCompetencyName == null || this.subCompetencyName == "") {
        this.subCompetencyName = sessionStorage.getItem("SubcompTitle")
      }

    });

    //this.handleIdChange();

// const Params = {compId:Number(sessionStorage.getItem("compId")),serviceArea: sessionStorage.getItem("SubcompTitle")};
// this.cmfService.GetCMFDashboardData(Params).subscribe(
// (data: TrainingData) => {
//  this.trainingdata = this.CMFDashBoardData;
// this.trainingdata.TotalActiveTrainings=this.trainingdata.trainingsWidget.totalActiveTrainings
// this.trainingdata.UpcomingTrainings=this.trainingdata.trainingsWidget.upcomingTrainings
// this.trainingdata.TechTalks=this.trainingdata.trainingsWidget.TechTalks
// },
// (error) => {
// console.error('Error fetching dashboard data', error);
//  }
// ); 
}


  ngOnChanges(changes: SimpleChanges): void {
    this.trainingdata = this.CMFDashBoardData;
    this.trainingdata.TotalActiveTrainings=this.trainingdata.trainingsWidget.totalActiveTrainings
    this.trainingdata.UpcomingTrainings=this.trainingdata.trainingsWidget.upcomingTrainings
    this.trainingdata.TechTalks=this.trainingdata.trainingsWidget.TechTalks
  }


  handleIdChange() {
    this.service.serviceId$.subscribe(serviceId => {
      if (serviceId) {
        this.service.GettrainingCount(this.competencyId, serviceId).subscribe(value => {
          this.trainingcount = value;
        })
      }
    });
  }
  
  trainingsWidgetData: TrainingsWidgetModel;
  date1 = "2023-01-10T11:12:59.657Z"
  date2 = "2024-09-11T11:12:59.657Z"
  backToToolsGrid() {
    this.router.navigate(['Home/trainings']);
  }
  backToTrainingGrid1(name: string, id: string) {
    const sendData = {
      value: id,
      name: name,
    };
    this.othersService.updatetriningtypeId(sendData);
    sessionStorage.setItem("TrainingtypeId", sendData.value);
    sessionStorage.setItem("TrainingTypename", sendData.name);
    this.subCompetencyName = sessionStorage.getItem("SubcompTitle");
    const subCompName = this.subCompetencyName.includes('/')
      ? this.subCompetencyName.split('/').join('-')
      : this.subCompetencyName;
    this.router.navigate([`Home/CMF Portal/${this.competencyname}/${subCompName}/Trainings/${sendData.name}`]);
  }
}
export interface trainingtype {
  crossSkillCount: number,
  upSkillCount: number,
  techTalkCount: number,
}

interface TrainingData {
TotalActiveTrainings: number;
UpcomingTrainings:number;
TechTalks:number;


trainingsWidget: {
totalActiveTrainings: 0,
upcomingTrainings:0,
TechTalks:0
},
 
}